import { useEffect, useState } from 'react'
import { DataType } from '../../../../../tables'
import { FieldType, FieldValue, FilterField, Filters, O, option } from '../../../../../features/ui'
import { Labels } from '../../../../../features/data-types'
import { Tax, TaxType } from '../../../state/types'
import { useTaxHooks } from '../../../hooks/taxHooks'

type Props = {
    taxes: Tax[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'tax'

export const TaxFilters = (props: Props) => {
    const { taxes, onSearchStart, onSearchDone } = props

    const [searchText, setSearchText] = useState<string>()
    const [type, setType] = useState<TaxType>()

    const { searchTaxes } = useTaxHooks()

    useEffect(() => search(searchText, type), [taxes])

    const search = (
        searchTextParam?: string,
        typeParam?: TaxType
    ) => {
        onSearchStart()
        let taxList = taxes.filter(tax => !typeParam || tax.type === typeParam)
        taxList = searchTaxes(taxList, searchTextParam)
        setTimeout(() => onSearchDone(taxList), 100)
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText, type)
    }

    const onChangeType = (value?: FieldValue) => {
        const newType = value as O<TaxType>
        if (newType !== type) {
            setType(newType)
            search(searchText, newType)
        }
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por tipo, nombre o código',
        icon: 'search',
        onChange: handleSearch
    }

    const filterFields: FilterField[] = [
        {
            name: 'type',
            type: FieldType.SELECT,
            options: Object.values(TaxType).map(type => option(type, Labels.taxTypeLabel(type))),
            label: 'Tipo',
            space: 3,
            onChange: onChangeType
        }
    ]

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
            fields={filterFields}
        />
    )
}
